import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TelegramIcon from '@mui/icons-material/Telegram';
import TwitterIcon from '@mui/icons-material/X';
import { Tooltip } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

const SocialLink = styled.a`
    color: #000;
    transition: all 0.2s ease;

    &:hover {
        color: #3563f3;
        transform: translateY(-2px);
        background-color: rgba(53, 99, 243, 0.04);
    }
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    gap: 20px;
`;

const BSCSocialMedia: React.FC = () => {
    return (
        <Wrapper>
            <Tooltip title="Telegram Group">
                <SocialLink
                    href="http://www.t.me/lazbubufrens"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <TelegramIcon />
                </SocialLink>
            </Tooltip>
            <Tooltip title="X (Twitter)">
                <SocialLink
                    href="https://x.com/lazbubuai"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <TwitterIcon />
                </SocialLink>
            </Tooltip>

            <Tooltip title="LinkedIn">
                <SocialLink
                    href="https://www.linkedin.com/company/lazbubu/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <LinkedInIcon />
                </SocialLink>
            </Tooltip>
        </Wrapper>
    );
};

export default BSCSocialMedia;
